import buyBoxStyles from '../BuyBox/BuyBox.styles.scss'

export const ActionsContainer: React.FC = ({ children }) => (
  <div className={buyBoxStyles.BuyBox__actionsContainer}>{children}</div>
)
